interface FAQItem {
  question: string;
  answer: string[];  
  highlights?: string[]; 
}

export const ADVANTAGES = [
  {
    icon: "/advertise-img/iconone",
    title: "Rentabilidade",
    text: "Rentabilize o seu imóvel e tenha a tranquilidade da receita recorrente.",
  },
  {
    icon: "/advertise-img/icontwo",
    title: "Menos Burocracia",
    text: "Processo de burocracia ágil e eficiente.",
  },
  {
    icon: "/advertise-img/iconthree",
    title: "Liberdade Total",
    text: "Anuncie seu imóvel de outras formas sem exclusividade.",
  },
  {
    icon: "/advertise-img/iconfour",
    title: "Segurança",
    text: "Tecnologia de ponta e equipe capacitada.",
  },
];

export const STEPSS= [
  {
    title: 'Você Anuncia Gratuitamente',
    description: 'Acesse nosso site e cadastre seu imóvel para publicação sem nenhum custo',
    image: '/advertise-img/iconnjone',
    number: '01',
  },
  {
    title: 'Fotos Profissionais',
    description: 'Nosso time de fotógrafos registra as melhores imagens do seu imóvel, tornando o anúncio mais atrativo e desejado.',
    image: '/advertise-img/iconnjtwo',
    number: '02',
  },
  {
    title: 'Visitas e Propostas',
    description: 'As visitas são acompanhadas pelo nosso time próprio de corretores, e você acompanha as visitas e as propostas pela nossa plataforma.',
    image: '/advertise-img/iconnjthree',
    number: '03',
  },
  {
    title: 'Assinatura Eletrônica',
    description: 'Após chegar a um acordo com o inquilino você assina seu contrato de locação de forma digital, com praticidade e segurança',
    image: '/advertise-img/iconnjthree',
    number: '04',
  },
];


export const BENEFITSICONS = [
  "/advertise-img/iconone",
  "/advertise-img/icontwo",
  "/advertise-img/iconthree", 
  "/advertise-img/iconfour"
];

export const STATS = [
  { value: 3000, label: "locações realizadas" },
  { value: 97, label: "taxa de renovação de contratos", isPercentage: true },
  { value: 2000, label: "avaliações positivas de inquilinos" },
  { value: 100, label: "inquilinos verificados e aprovados" },
];


export const FAQ_DATA = [
  {
    question: "Quanto eu pago para anunciar meu imóvel com a 7Cantos?",
    answer: [
      "Você não paga nada para anunciar seu imóvel na plataforma. A 7Cantos cobra apenas se o imóvel for alugado com a ajuda da plataforma, retendo o primeiro aluguel. Ou seja, você só paga se obtiver resultados!",
      "",
      "Após o imóvel ser alugado, você tem duas opções:",
      "",
      "• Administrar o imóvel por conta própria: nesse caso, você não paga nada à 7Cantos.",
      "",
      "• Contratar os serviços de suporte ao contrato de locação da 7Cantos: nesse caso, você paga 10% do valor do aluguel por mês. Essa opção garante que qualquer problema relacionado ao imóvel seja intermediado e, na maioria das vezes, resolvido pela equipe da 7Cantos"
    ]
  },
  {
    question: "Quais garantias oferecem aos proprietários em relação ao pagamento do aluguel?",
    answer: [
      "As garantias oferecidas aos proprietários em relação ao pagamento do aluguel são:",
      "",
      "1. Seguro Fiança:",
      "• A 7Cantos oferece a opção de contratar um Seguro Fiança, que garante o pagamento do aluguel em caso de inadimplência do inquilino.",
      "• O custo do Seguro Fiança é de responsabilidade do inquilino e varia de acordo com o valor do aluguel.",
      "• A 7Cantos trabalha com diversas companhias de seguro para oferecer aos proprietários a melhor opção de acordo com suas necessidades.",
      "",
      "2. Fiador:",
      "• O proprietário pode solicitar um fiador que seja solidariamente responsável pelo pagamento do aluguel.",
      "• O fiador deve ter renda compatível com o valor do aluguel e apresentar documentos comprobatórios.",
      "• A 7Cantos verifica a idoneidade do fiador antes de aprovar a locação.",
      "",
      "3. Depósito caução:",
      "• O proprietário pode solicitar um depósito caução equivalente a um mês de aluguel.",
      "• O depósito caução é devolvido ao inquilino ao final do contrato de locação, desde que não haja pendências.",
      "",
      "4. Outras medidas:",
      "• A 7Cantos realiza uma análise de crédito do inquilino antes de aprovar a locação.",
      "• A plataforma também oferece aos proprietários a opção de contratar um serviço de acompanhamento de inadimplência."
    ]
  },
  {
    question: "Como a 7Cantos lida com a seleção e verificação de inquilinos?",
    answer: [
      "A 7Cantos se dedica a oferecer uma experiência de aluguel segura e eficiente para todos os envolvidos. Para garantir a qualidade dos inquilinos e a segurança dos proprietários, a empresa implementa um processo rigoroso de seleção e verificação.",
      "",
      "Processo de Seleção e Verificação de Inquilinos da 7Cantos:",
      "",
      "1. Análise de Crédito:",
      "• A 7Cantos consulta os órgãos de proteção ao crédito (SPC e Serasa) para verificar a situação financeira do candidato.",
      "• É importante que o inquilino não tenha pendências financeiras em aberto.",
      "• A plataforma também avalia o histórico de pagamento de aluguéis anteriores, se disponível.",
      "",
      "2. Comprovação de Renda:",
      "• O inquilino deve apresentar documentos que comprovem renda compatível com o valor do aluguel.",
      "• A renda mínima exigida geralmente é de 3 vezes o valor do aluguel.",
      "• São aceitos como comprovantes de renda: holerites, contracheques, extratos bancários, declaração de imposto de renda, entre outros.",
      "",
      "3. Fiador ou Seguro Fiança:",
      "• O fiador deve ter renda compatível com o valor do aluguel e apresentar documentos comprobatórios.",
      "• O Seguro Fiança é uma opção paga pelo inquilino que garante o pagamento do aluguel em caso de inadimplência.",
      "",
      "4. Vistoria do Imóvel:",
      "• Antes da assinatura do contrato, o vistoriador realiza uma vistoria no imóvel para verificar as condições do mesmo, a vistoria é assinada por ambas as partes.",
      "• A vistoria é documentada com fotos e um relatório detalhado.",
      "• É importante que o inquilino esteja ciente de todos os danos existentes no imóvel antes de se mudar.",
      "",
      "5. Assinatura do Contrato:",
      "• O contrato de aluguel deve ser lido com atenção antes de ser assinado.",
      "• O contrato deve conter todas as informações relevantes sobre o imóvel, o aluguel, as responsabilidades do inquilino e do proprietário, entre outras.",
      "",
      "6. Outras medidas:",
      "• A 7Cantos pode realizar entrevistas com os candidatos para conhecê-los melhor.",
      "• A plataforma também pode verificar as referências pessoais e profissionais do inquilino.",
      "",
      "Benefícios da Seleção Rigorosa da 7Cantos:",
      "• Maior segurança para os proprietários: diminui o risco de inadimplência e de problemas com o imóvel.",
      "• Tranquilidade para os inquilinos: garante um processo de aluguel transparente e justo.",
      "• Qualidade dos imóveis: a plataforma se dedica a oferecer imóveis em boas condições para seus clientes."
    ]
  },
  {
    question: "Como é feita a manutenção do meu imóvel durante o período de locação?",
    answer: [
      "A manutenção do seu imóvel durante o período de locação na 7Cantos pode ser feita de duas maneiras, dependendo da sua escolha:",
      "",
      "1. Você administra a manutenção:",
      "• Responsabilidade: Você é responsável por todos os custos e organização da manutenção.",
      "• Liberdade: Você tem a liberdade de escolher os profissionais e empresas que deseja contratar.",
      "",
      "2. 7Cantos administra a manutenção (Serviço Opcional):",
      "• Custo: Serviço pago por você, com valor equivalente a 10% do aluguel mensal.",
      "• Comodidade: A 7Cantos se encarrega de tudo: desde a identificação do problema até a contratação de profissionais e resolução do problema.",
      "• Tranquilidade: Você não precisa se preocupar com nada, a equipe da 7Cantos cuida de tudo para você.",
      "• Importante: A taxa de 10% da 7Cantos não cobre o valor da manutenção. É uma taxa para intermediar a resolução de problemas e oferecer comodidade.",
      "",
      "Em ambos os casos:",
      "• Vistoria inicial: Uma vistoria é realizada antes do início da locação para documentar as condições do imóvel.",
      "• Comunicação: É importante que o inquilino informe o proprietário sobre qualquer problema de manutenção que surja durante o período de locação.",
      "• Responsabilidades: O contrato de locação define as responsabilidades de cada parte em relação à manutenção do imóvel.",
      "",
      "Outras informações importantes:",
      "• A 7Cantos oferece um serviço de assistência jurídica para auxiliar os proprietários em caso de problemas com a manutenção do imóvel.",
      "• A plataforma também oferece um serviço de acompanhamento de inadimplência para garantir que o inquilino pague o aluguel em dia.",
      "• A Lei do Inquilinato define quem é responsável por pagar a manutenção do imóvel durante a locação.",
      "• Proprietário: É responsável por reparos estruturais e problemas que afetam o habitabilidade do imóvel, como vazamentos, problemas elétricos, etc.",
      "• Inquilino: É responsável por reparos de pequeno porte e danos causados pelo uso regular do imóvel, como pintura, troca de lâmpadas, etc."
    ]
  },
  {
    question: "Como a 7Cantos lida em relação a possíveis conflitos entre proprietário e inquilino?",
    answer: [
      "A 7Cantos se dedica a ser uma plataforma transparente e justa para ambas as partes. Para isso, implementamos medidas para prevenir e solucionar conflitos entre proprietários e inquilinos nos imóveis administrados pela plataforma:",
      "",
      "1. Prevenção:",
      "• Contrato de Aluguel Claro e Detalhado: O contrato define as responsabilidades de cada parte, como pagamento do aluguel, manutenção do imóvel, etc.",
      "• Comunicação Aberta: Incentivamos a comunicação clara e frequente entre proprietário e inquilino para evitar mal-entendidos.",
      "• Mediação: A 7Cantos oferece mediação gratuita em caso de desavenças entre as partes.",
      "",
      "2. Solução:",
      "• Processo de Resolução de Conflitos: Em caso de conflito mais sério, a 7Cantos possui um processo estruturado para buscar uma solução justa.",
      "• Notificação Formal: As partes são notificadas formalmente sobre o problema e seus direitos e responsabilidades.",
      "• Negociação Assistida: A 7Cantos auxilia na negociação entre as partes para que cheguem a um acordo amigável.",
      "• Arbitragem: Se a negociação falhar, a 7Cantos pode oferecer arbitragem, um processo imparcial para resolver o conflito.",
      "",
      "Observações importantes:",
      "• A 7Cantos só oferece suporte para resolução de conflitos em imóveis sob sua administração.",
      "• Para imóveis não administrados pela 7Cantos, a plataforma não se envolve em conflitos entre proprietários e inquilinos.",
      "• A 7Cantos incentiva os proprietários a buscar soluções amigáveis e justas para os conflitos."
    ]
  },
  {
    question: "Como é feita a divulgação do meu imóvel para potenciais inquilinos?",
    answer: [
      "A 7Cantos utiliza uma combinação de estratégias para divulgar seu imóvel para o maior número possível de inquilinos:",
      "",
      "Plataforma 7Cantos:",
      "• Anúncio Gratuito: Seu imóvel recebe um anúncio completo e profissional em nossa plataforma, com fotos de alta qualidade, descrição detalhada e todas as informações relevantes.",
      "• Visibilidade Ampla: O anúncio do seu imóvel é facilmente encontrado pelos inquilinos que buscam por imóveis na região e com as características desejadas.",
      "• Filtros de Busca: Os inquilinos podem filtrar a busca por diversos critérios, como localização, tipo de imóvel, preço, número de quartos, etc., aumentando as chances de seu imóvel ser encontrado.",
      "",
      "Redes Sociais:",
      "• Divulgação em Múltiplas Plataformas: Divulgamos seu imóvel em nossas redes sociais (Facebook, Instagram, etc.) para alcançar um público ainda maior.",
      "• Conteúdo Atraente: Criamos posts e anúncios com fotos e vídeos de alta qualidade para atrair a atenção dos potenciais inquilinos.",
      "• Segmentação por Localização: Direcionamos as campanhas para as regiões onde há maior interesse em imóveis como o seu.",
      "",
      "Parcerias:",
      "• Imobiliárias: Anunciamos seu imóvel em sites e portais de parceiros, expandindo o alcance da divulgação.",
      "• Sites de Busca: Anunciamos seu imóvel em sites de busca de imóveis, como OLX e Viva Real, para aumentar a visibilidade.",
      "",
      "Outras Estratégias:",
      "• E-mail Marketing: Enviamos e-mails para nossa base de dados de inquilinos interessados, informando sobre novos imóveis disponíveis, incluindo o seu.",
      "• Campanhas de Marketing: Realizamos campanhas de marketing direcionadas para promover o seu imóvel e gerar interesse entre os inquilinos.",
      "",
      "Todas as estratégias de divulgação são utilizadas de forma integrada para garantir que seu imóvel seja visto pelo maior número possível de inquilinos."
    ]
  }
];